import React from 'react'
import * as ReactDOM from 'react-dom'
import {Theme} from '..'

export const PortalBody: ({children}: any) => React.ReactPortal = ({children}: any) =>
  ReactDOM.createPortal(<Theme>{children}</Theme>, document.body)
